import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { MarketoObjectDataset } from 'app/model/dataset/marketo.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MarketoObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class MarketoObjectDatasetAdapter extends TabularTypeDatasetAdapter<MarketoObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: MarketoObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(MarketoObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: MarketoObjectDataset): Promise<MarketoObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, MarketoObjectDataset.MODEL);
    }
}
